import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import Draggable from "react-draggable";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useCart } from "react-use-cart";
import toast from "react-hot-toast";
import axiosInstance, { Homeurl } from "../../axiosInstance";
import { Swiper, SwiperSlide } from "swiper/react";
import Magnifier from "../components/extra/Magnifier";

import QuantitySelector from "../components/extra/QuantitySelector";

// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import { useBlogContext } from "../../fetchdata/BlogContext";
import { Helmet } from "react-helmet";
import getCookie from "../../helper/getCookie";
import CreateSlug from "../components/extra/CreateSlug";
import getDecryptData from "../../helper/getDecryptData";
import HeaderPage from "../components/HeaderPage";
import NavBar from "../components/NavBar";

const ProductSlug = () => {


  const tableRef = useRef(null);


  const [tableData, setTableData] = useState({
    headers: [],
    rows: [],
  });



  const navigate = useNavigate();

  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [Products, setProducts] = useState([]);

  // const userId = localStorage.getItem('userId');
  const getdata = getDecryptData();
  const userId = getdata?._id || null;

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state

  const [SubmitWishlist, setWishlistLoading] = useState(true); // Add loading state

  const [SubmitCompare, setCompareLoading] = useState(true); // Add loading state

  const {
    Headers,
    isHeader,
    addItemToCart,
    cartItems,
    promoCodeInfo,
    updateItemQuantity,
  } = useBlogContext();

  const [selectedValues, setSelectedValues] = useState([]);

  const [ValuesVariant, setValuesVariant] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const [selectedCombination, setSelectedCombination] = useState({});

  const [ProductsRegular, setProductsRegular] = useState(0);
  const [ProductsSale, setProductsSale] = useState(0);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const { id, slug } = useParams();

  const [formData, setFormData] = useState({
    userId: userId || "",
    productId: id,
    rating: "",
    comment: "",
  });




  useEffect(() => {
    setIsLoading(true);
    setIsProducts(true);
    // Update the productId in the formData when id changes
    setFormData((prevState) => ({
      ...prevState,
      productId: id,
      rating: "",
      comment: "",
    }));
  }, [id]); // This useEffect will re-run whenever id changes


  const [selectedColor, setSelectedColor] = useState(""); // State to hold the selected color

  const [pdfBase64, setPdfBase64] = useState(""); // State to hold the PDF as Base64 string

  const [SelectedSizes, setSelectedSizes] = useState({});
  const [TotalQuantity, setTotalQuantity] = useState(1);

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [thumbsVarSwiper, setThumbsVarSwiper] = useState(null);

  const [isOpenReview, setIsOpenReview] = useState(false);
  const [activeData, setActiveData] = useState([]);


  const [ChooseDateTime, setChooseDateTime] = useState(false);


  const toggleReviewPopup = () => {
    if (userId && getdata) {
      setIsOpenReview(!isOpenReview);
    } else {
      toast.error("Please Login First", TotalQuantity);
    }
  };

  const getProducts = async () => {
    const decryptdatajson = await getDecryptData();
    if (decryptdatajson && decryptdatajson?._id) {

      setEnquireData((prevData) => ({
        ...prevData,
        fullname: decryptdatajson.username,
        email: decryptdatajson.email,
        phone: decryptdatajson.phone,

      })); // Clear form fields
    }

    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getData();
    getProducts();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {

          setEnquireData((prevData) => ({
            ...prevData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })); // Clear form fields

          console.log("Latitude:", position.coords.latitude);
          console.log("Longitude:", position.coords.longitude);
        },

      );
    } else {
      toast.error('Geolocation is not supported by this browser.');
      return null;
    }



  }, [slug]);



  const handleAddToCart = async (product, buy) => {


    const existingProduct = cartItems.find((item) => item.id === product.id);
    if (existingProduct) {
      // const updatedQuantity = existingProduct.quantity + 1;
      const updatedQuantity = TotalQuantity;
      console.log("updatedQuantity", updatedQuantity);

      updateItemQuantity(
        existingProduct.id,
        cartItems.find((item) => item.id === existingProduct.id).quantity +
        updatedQuantity
      );

      if (buy) {
        navigate("/checkout");
      }
      toast.success("Product quantity updated in cart");
    } else {
      await addItemToCart(
        { ...product, color: selectedColor, TotalQuantity },
        TotalQuantity
      );

      // updateItemQuantity(product.id, updatedQuantity);

      if (buy) {
        navigate("/checkout");
      }
      // toast.success("Product Added To Cart");
    }

  };

  const handleBuyNow = (product) => {
    const buy = TotalQuantity;
    handleAddToCart(product, buy);
  };

  const [frontImage, setFrontImage] = useState(null);


  const [loading, setLoading] = useState(true); // Add loading state
  const [Image, setImage] = useState("");
  const [Specifications, setspecifications] = useState([]);

  const [mainImage, setMainImage] = useState("");

  const [Product, setProduct] = useState({});
  const [Attr, setAttr] = useState([]);
  const [sizeQuantities, setSizeQuantities] = useState({});
  const [variations, setVariations] = useState([]);
  const [Images, SetImages] = useState([]);

  const [variationsSize, setVariationsSize] = useState([]);
  const [Testimonial, setTestimonial] = useState([]);

  const [Varloading, SetVarLoading] = useState(true); // Add loading state
  const [ratings, setRatings] = useState([]);
  const [totalRating, settotalRating] = useState("");
  const [averageRating, setaverageRating] = useState("");
  const [HSNvariations, setHSNVariations] = useState({});
  const [selectedVariation, setSelectedVariation] = useState(null);

  const [variationsmap, setVariationsmap] = useState([]);
  const [prohsn, setprohsn] = useState("");

  const [activevariations, setactiveVariations] = useState({});

  const handleSmallImageClick = (newImageSrc) => {
    setFrontImage(newImageSrc);
  };

  const [enquireData, setEnquireData] = useState([]);
  const [dateTimeData, setDateTimeData] = useState([]);

  const getProduct = async () => {
    window.scrollTo(0, 0);
    setLoading(true); // Set loading to false when data is fetched
    SetVarLoading(true);

    console.log('__PRELOADED_DATA__', window.__PRELOADED_DATA__?.slug, slug);
    if (window.__PRELOADED_DATA__?.slug !== slug || window.__PRELOADED_DATA__ === undefined) {
      try {
        const { data } = await axiosInstance.get(`/user-product-slug/${slug}`);
        setProduct(data.Product);
        // setVariations(data.Product.variations.Color || []);
        // setVariationsSize(data.Product.variations.Size);
        SetImages(data.Product.images);
        setFrontImage(data.Product.pImage);
        setspecifications(data.Product.specifications.specifications || []);
        setSelectedValues(data.Product.variations);
        setProductCoverage(data.Product.coverage);
        setEnquireData((prevData) => ({
          ...prevData,
          service: data.Product?.title,
          category: data.Product?.Category,
        })); // Clear form fields
        setprohsn(data.Product.hsn || "");
        setActiveData(data.Product.variations);
        setValuesVariant(data.Product?.variant_products);
        setProductsRegular(data.Product?.regularPrice || 0);
        setProductsSale(data.Product?.salePrice || 0);
        setTestimonial(data.Product?.testimonials || []);
        const extraContent =
          Array.isArray(data.Product?.extra_content) &&
            data.Product.extra_content.length > 0 &&
            Array.isArray(data.Product.extra_content[0]?.headers) &&
            Array.isArray(data.Product.extra_content[0]?.rows)
            ? data.Product.extra_content[0]
            : { headers: [], rows: [] };

        setTableData(extraContent);

        const firstVisibleProduct = data.Product?.variant_products && data.Product?.variant_products.find(
          (product) => product.visible === true
        );

        if (firstVisibleProduct) {
          const {
            regular_price,
            sale_price,
            qty,
            visible,
            images,
            ...filteredProduct
          } = firstVisibleProduct;

          setSelectedCombination(filteredProduct);

          console.log("firstVisibleProduct", filteredProduct);

        }
        // getRating(data.Product._id);
      } catch (error) {
        console.error("Error getting product:", error);
        // navigate("/404");
      } finally {
        setLoading(false); // Set loading to false when data is fetched
        SetVarLoading(false);
        console.log("Image", Image);
      }
    } else {
      setLoading(false); // Set loading to false when data is fetched
      SetVarLoading(false);
      setIsLoading(false);

      setProduct(window.__PRELOADED_DATA__);
      // setVariations(data.Product.variations.Color || []);
      // setVariationsSize(data.Product.variations.Size);
      SetImages(window.__PRELOADED_DATA__.images);
      setFrontImage(window.__PRELOADED_DATA__.pImage);
      setspecifications(window.__PRELOADED_DATA__.specifications.specifications || []);
      setSelectedValues(window.__PRELOADED_DATA__.variations);
      setTestimonial(window.__PRELOADED_DATA__.testimonials || []);

      setEnquireData((prevData) => ({
        ...prevData,
        service: window.__PRELOADED_DATA__?.title,
      })); // Clear form fields

      // console.log("product data", data);
      setprohsn(window.__PRELOADED_DATA__.hsn || "");
      setActiveData(window.__PRELOADED_DATA__.variations);
      setValuesVariant(window.__PRELOADED_DATA__?.variant_products);
      setProductsRegular(window.__PRELOADED_DATA__?.regularPrice || 0);
      setProductsSale(window.__PRELOADED_DATA__?.salePrice || 0);
      const firstVisibleProduct = window.__PRELOADED_DATA__?.variant_products.find(
        (product) => product.visible === true
      );

      if (firstVisibleProduct) {
        const {
          regular_price,
          sale_price,
          qty,
          visible,
          images,
          ...filteredProduct
        } = firstVisibleProduct;

        setSelectedCombination(filteredProduct);

        console.log("firstVisibleProduct", filteredProduct);
      }

      setLoading(false); // Set loading to false when data is fetched
      SetVarLoading(false);
      // getRating();
    }


  };



  const handleIncrement = (stock) => {
    if (TotalQuantity <= stock) {
      // Check input length before updating

      setTotalQuantity(TotalQuantity + 1);
    } else {
      toast.error("Product out of stock. ");
    }
  };

  const handleDecrement = () => {
    if (TotalQuantity > 1) {
      setTotalQuantity(TotalQuantity - 1);
    }
  };

  const handleQuantityChange = (event) => {
    const newQuantity = parseInt(event.target.value);
    if (!isNaN(newQuantity) && newQuantity >= 1) {
      setTotalQuantity(newQuantity);
    }
  };

  useEffect(() => {
    // setVariationsmap([]); 
    getProduct();
    // getAttribute();
  }, [slug]);

  // product zoom js

  const [isZoomed, setIsZoomed] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const handleMouseEnter = (product) => {
    setIsZoomed(true);
    setHoveredProduct(product);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
    setHoveredProduct(null);
  };

  const handleMouseMove = (e) => {
    setCursorPosition({
      x: (e.nativeEvent.offsetX / e.target.offsetWidth) * 100,
      y: (e.nativeEvent.offsetY / e.target.offsetHeight) * 100,
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const AddWhishlistData = async () => {
    setWishlistLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setWishlistLoading(true);
    } else {
      try {
        await axiosInstance.post("/add-wishlist", formData);
        toast.success("wishlist Added successfully!");
      } catch (error) {
        console.error("Error on wishlist added:", error);
        toast.error(error.response.data.message);
      } finally {
        setWishlistLoading(true);
      }
    }
  };

  const AddCompareData = async () => {
    setCompareLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setCompareLoading(true);
    } else {
      try {
        await axiosInstance.post("/add-compare", formData);
        toast.success("Comparsion Added successfully!");
      } catch (error) {
        console.error("Error on compare added:", error);
        toast.error(error.response.data.message);
      } finally {
        setCompareLoading(true);
      }
    }
  };

  const submitData = async () => {
    setSubmitLoading(false);

    if (!userId) {
      toast.error("Please Login First");
      setSubmitLoading(true);
      return;
    } else {
      if (formData.rating !== "" || formData.comment !== "") {
        const mydata = {
          rating: formData.rating,
          comment: formData.comment,
          userId: userId,
          productId: Product._id,
        }
        try {
          await axiosInstance.post("/add-rating", mydata);
          toggleReviewPopup();
          toast.success("Rating Added successfully!");

          const timer = setTimeout(() => {
            window.location.reload();
          }, 100);
          return () => clearTimeout(timer);

        } catch (error) {
          console.error("Error on rating added:", error);
          toast.error(error.response.data.message);
          setRatings([]);
        } finally {
          setSubmitLoading(true);
        }
      } else {
        toast.error("Please Fill All Fields");
        setSubmitLoading(true);
      }
    }
  };

  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  }

  const [MatchImages, setMatchImages] = useState([]);
  const [ProductVariantName, setProductVariantName] = useState("");
  const [ProductuniqueId, setProductuniqueId] = useState("");
  const [ProductCoverage, setProductCoverage] = useState([]);


  // Function to handle button click and update selected variant
  // Function to handle button click and update selected variant
  const handleVariantButtonClick_old = (name, value) => {
    const newSelectedCombination = { ...selectedCombination, [name]: value };
    setSelectedCombination(newSelectedCombination);
  };

  const handleVariantButtonClick = (name, value) => {

    // Update selected combination
    const newSelectedCombination = { ...selectedCombination, [name]: value };

    console.log('newSelectedCombination', newSelectedCombination);
    setSelectedCombination(newSelectedCombination);
  };

  useEffect(() => {
    const filteredVariants = ValuesVariant.filter(
      (variant) => variant.visible === true
    );

    console.log("Filtered Variants:", filteredVariants);

    const allRowsSelected = selectedValues.every((variant) =>
      variant.value.some((val) => selectedCombination[variant.name] === val)
    );

    const variantsWithId = filteredVariants.map((variant, index) => ({
      ...variant,
      id: index + 1, // or use uuidv4() for unique id

    }));

    console.log("All Rows Selected:", allRowsSelected);

    if (allRowsSelected) {
      const matchedVariant = variantsWithId.find((variant) =>
        Object.keys(selectedCombination).every(
          (key) => variant[key] === selectedCombination[key]
        )
      );

      console.log("Matched Variant:", matchedVariant);

      if (matchedVariant) {
        const location = localStorage.getItem("location"); // Get location from localStorage

        // Add safety check for ProductCoverage
        const match = Array.isArray(ProductCoverage)
          ? ProductCoverage.find(item => item.city === location)
          : null;

        const coveragePrice = match ? Number(match.price) : 0;

        const regularPrice = Number(matchedVariant.regular_price);
        const salePrice = Number(matchedVariant.sale_price);

        setProductsRegular(regularPrice + coveragePrice);
        setProductsSale(salePrice + coveragePrice);

        console.log("Price:", matchedVariant.regular_price);
        console.log("Sale Price:", matchedVariant.sale_price);

        setProductuniqueId(matchedVariant.id);
        setMatchImages(matchedVariant.images);

        const { regular_price, sale_price, qty, visible, images, id, ...rest } = matchedVariant;

        const restString = `[ ${Object.entries(rest)
          .map(([key, value]) => `${key}: ${value}`)
          .join(", ")} ]`;
        setProductVariantName(" " + restString);
      } else {
        console.log("No matching variant found for the selected combination.");
      }

    } else {
      console.log("Not all combinations selected.");
    }
  }, [selectedCombination]);

  const removeSelectedFillter = () => {
    setSelectedCombination([]);
    setMatchImages([]);
    setProductsRegular(0);
    setProductsSale(0);
    setProductVariantName("");
    toast.success("Attribute Cleared Successfully");
  };

  const isCombinationPossible = (name, value) => {
    const newSelectedCombination = { ...selectedCombination, [name]: value };

    const visibleVariants = ValuesVariant.filter((variant) => variant.visible);

    return visibleVariants.some((variant) =>
      Object.keys(newSelectedCombination).every(
        (key) =>
          !newSelectedCombination[key] ||
          variant[key] === newSelectedCombination[key]
      )
    );
  };

  const [EnquireShow, setEnquireShow] = useState(false);

  const [EnquireStatus, setEnquireStatus] = useState(false);

  const [StepForm, setStepForm] = useState(0);

  const handleNext = () => {
    setStepForm((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStepForm((prevStep) => prevStep - 1);
  };


  const enquireToggle = () => {
    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      setEnquireShow(true);
    }
  };

  const dateTimeToggle = () => {
    if (ChooseDateTime) {
      setChooseDateTime(false);
    } else {
      setChooseDateTime(true);
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };






  return (
    <>
      <HeaderPage title={!isLoading ? Product.title || 'Not Found' : ''} />

      <main className="page-content  mypadding bg-light overflow-auto pb-4 px-0" >


        <div className="bg-white px-3 py-2">

          {/* Product gallery */}
          <div className="col-12 productpage">
            {frontImage && (
              <>
                <div className={`${MatchImages.length === 0 && "d-none"}`}>
                  <Swiper
                    onClick={togglePopup}
                    style={{
                      "--swiper-navigation-color": "#335599",
                      "--swiper-pagination-color": "#335599",
                    }}
                    spaceBetween={10}
                    navigation={true}
                    thumbs={{ swiper: thumbsVarSwiper }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className={`mySwiper2 hide-desk-pagenation ${isLoading && "d-none"
                      } `}
                  >
                    {MatchImages.map((imageUrl, index) => (
                      <SwiperSlide key={index}>
                        <div

                        >
                          <img
                            src={imageUrl.src}
                            onMouseEnter={() =>
                              handleMouseEnter(imageUrl.src)
                            }
                            onMouseLeave={handleMouseLeave}
                            onMouseMove={handleMouseMove}
                            className="m-auto d-block"
                            alt="Product Image"
                            style={{
                              height: "auto",
                              width: "100%",
                              objectFit: "cover",
                              cursor: "url(/assets/img/zoomm.png), auto",
                              aspectRatio: '1/1',
                              borderRadius: '20px',
                              overflow: 'hidden'
                            }}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <Swiper
                    onSwiper={setThumbsVarSwiper}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className={`mySwiper ${isLoading && "d-none"}   `}
                  >
                    {MatchImages.map((imageUrl, index) => (
                      <SwiperSlide key={index}>
                        <img
                          src={imageUrl.src}
                          alt="Product Image"
                          style={{
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                          }}
                          className="w-100"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </>
            )}

            {frontImage && (
              <>
                <div className={`${MatchImages.length !== 0 && "d-none"}`}>
                  <Swiper
                    onClick={togglePopup}
                    style={{
                      "--swiper-navigation-color": "#335599",
                      "--swiper-pagination-color": "#335599",
                    }}
                    spaceBetween={10}
                    navigation={true}
                    thumbs={{ swiper: thumbsSwiper }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className={`mySwiper2 hide-desk-pagenation ${isLoading && "d-none"
                      }  ${MatchImages.length !== 0 && "d-none"}`}
                  >
                    <SwiperSlide>
                      <div
                        className="overflow-hidden rounded"
                      >
                        <img
                          src={frontImage}
                          onMouseEnter={() => handleMouseEnter(frontImage)}
                          onMouseLeave={handleMouseLeave}
                          onMouseMove={handleMouseMove}
                          className="m-auto d-block"
                          alt="Product Image"
                          style={{
                            height: "auto",
                            width: "100%",
                            objectFit: "cover",
                            // cursor: "url(/assets/img/zoomm.png), auto",
                            aspectRatio: "1 / 1",
                          }}
                        />
                      </div>
                    </SwiperSlide>

                    {Images.map((imageUrl, index) => (
                      <SwiperSlide key={index}>
                        <div
                          className="overflow-hidden rounded"
                        >
                          <img
                            src={imageUrl}
                            onMouseEnter={() => handleMouseEnter(imageUrl)}
                            onMouseLeave={handleMouseLeave}
                            onMouseMove={handleMouseMove}
                            className="m-auto d-block"
                            alt="Product Image"
                            style={{
                              height: "auto",
                              width: "100%",
                              objectFit: "cover",
                              // cursor: "url(/assets/img/zoomm.png), auto",
                              aspectRatio: "1 / 1",
                            }}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className={`mySwiper p-0 ${isLoading && "d-none"}  d-none `}
                  >
                    <SwiperSlide>
                      <img
                        src={frontImage}
                        alt="Product Image"
                        style={{
                          aspectRatio: "1 / 1",
                          objectFit: "cover",
                        }}
                        className="w-100"
                      />
                    </SwiperSlide>

                    {Images.map((imageUrl, index) => (
                      <SwiperSlide key={index}>
                        <img
                          src={imageUrl}
                          alt="Product Image"
                          style={{
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                          }}
                          className="w-100"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </>
            )}

            {isLoading && (
              <>
                <div
                  className="card-1 skeleton w-100"
                  style={{ aspectRatio: '1/1', borderRadius: 20 }}
                ></div>
              </>
            )}
          </div>




          <div className="product-details">
            {/* Zoom overlay */}

            {isZoomed && hoveredProduct && (
              <div
                className="zoom-overlay"
                style={{
                  backgroundImage: `url(${hoveredProduct})`,
                  backgroundPosition: `${cursorPosition.x}% ${cursorPosition.y}%`,
                  backgroundColor: "white",
                }}
              ></div>
            )}

            <h1 className="product-title fs-3">
              {Product && !isLoading ? (
                <>{Product.title} </>
              ) : (
                <>
                  <div className=" border-bottom pb-2 mb-2 mt-2">
                    {" "}
                    <div
                      className="card-1 skeleton"
                      style={{ height: 32, borderRadius: 5 }}
                    ></div>
                  </div>
                </>
              )}
            </h1>

            <div className="border-bottom pb-2 mb-2 d-none">
              {!averageRating || (!totalRating && !isLoading) ? (
                <>
                  <span
                    className={`star-rating star-0 } fs-6 align-middle`}
                  />
                  <span className="d-inline-block fs-sm ms-2">
                    0 by 0 Reviews
                  </span>
                </>
              ) : (
                <>
                  <span
                    className={`star-rating star-${averageRating * 2
                      } fs-6 align-middle`}
                  />
                  <span className="d-inline-block fs-sm ms-2">
                    {averageRating} by {totalRating} Reviews
                  </span>
                </>
              )}
            </div>
            {/* Product Price */}
            <div className="product-price mb-3">
              {Product && !isLoading ? (
                <>
                  {ProductsSale ? (
                    <div className="row g-2">
                      <div className="col-auto d-flex flex-column justify-content-center">
                        <span className="text-accent fs-2">
                          ₹{ProductsSale}
                        </span>
                      </div>
                      <div className="col d-flex flex-column justify-content-center">
                        <del className="text-body-secondary">
                          <span className="fs-sm">
                            ₹{ProductsRegular}
                          </span>
                        </del>
                        <span className="text-danger fs-sm mt-n1">
                          You save{" "}
                          {Math.round(
                            ((ProductsRegular - ProductsSale) /
                              ProductsRegular) *
                            100
                          )}
                          % (₹{ProductsRegular - ProductsSale})
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <p className="text-danger fw-bold">
                        {" "}
                        Price On Request{" "}
                      </p>
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="row g-2 mb-2">
                    <div
                      className="card-1 skeleton"
                      style={{
                        height: 56,
                        borderRadius: 10,
                        width: "50%",
                      }}
                    ></div>
                  </div>
                </>
              )}
            </div>
            {/* Product Price */}


            <div class="variationsmapbutton mb-4 ">
              {isLoading ? (
                <>
                  {Array.from({ length: 1 }).map((_, index) => (
                    <div key={index}>
                      <div
                        className="card-1 skeleton mb-2"
                        style={{
                          height: 20,
                          width: 80,
                          maxWidth: "100%",
                          borderRadius: 5,
                        }}
                      ></div>
                      <div className="d-flex gap-2">
                        <div
                          className="card-1 skeleton mb-2"
                          style={{
                            height: 40,
                            width: 50,
                            maxWidth: "100%",
                            borderRadius: 5,
                          }}
                        ></div>
                        <div
                          className="card-1 skeleton mb-2"
                          style={{
                            height: 40,
                            width: 50,
                            maxWidth: "100%",
                            borderRadius: 5,
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                selectedValues &&
                selectedValues.length > 0 &&
                selectedValues.map((variant, index) => (
                  <div key={index} className="row d-block mb-2">
                    {variant.name === "Color" ? (
                      <>
                        <div className="col-md-12 mb-2 mb-2">
                          {" "}
                          <b> {variant.name} </b>
                        </div>
                        <div className="col-md-12">
                          {variant?.value.length > 0 &&
                            variant?.value.map((value, idx) => {
                              const isActive =
                                selectedCombination[variant.name] ===
                                value;
                              const isDisabled = !isCombinationPossible(
                                variant.name,
                                value
                              );
                              const firstVisibleProduct =
                                ValuesVariant.find(
                                  (product) =>
                                    product.Color === value &&
                                    product.images.length !== 0
                                );
                              const firstImage =
                                firstVisibleProduct?.images[0].src;

                              return (
                                <>
                                  {firstImage ? (
                                    <button
                                      key={idx}
                                      className={`img-button btn me-2 mb-2 ${isActive ? "active" : ""
                                        }`}
                                      onClick={() =>
                                        handleVariantButtonClick(
                                          variant.name,
                                          value
                                        )
                                      }
                                      disabled={isDisabled} // Disable if combination not possible
                                    >
                                      <img src={firstImage} width={80} />
                                      <span> {value} </span>
                                    </button>
                                  ) : (
                                    <button
                                      key={idx}
                                      className={`  btn me-2 ${isActive ? "active" : ""
                                        }`}
                                      onClick={() =>
                                        handleVariantButtonClick(
                                          variant.name,
                                          value
                                        )
                                      }
                                      disabled={isDisabled} // Disable if combination not possible
                                    >
                                      {value}
                                    </button>
                                  )}
                                </>
                              );
                            })}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-md-12 mb-2 mb-2">
                          {" "}
                          <b> {variant.name} </b>
                        </div>
                        <div className="col-md-12">
                          {variant?.value.length > 0 &&
                            variant?.value.map((value, idx) => {
                              const isActive =
                                selectedCombination[variant.name] ===
                                value;
                              const isDisabled = !isCombinationPossible(
                                variant.name,
                                value
                              );
                              return (
                                <button
                                  key={idx}
                                  className={`btn me-2 ${isActive ? "active" : ""
                                    }`}
                                  onClick={() =>
                                    handleVariantButtonClick(
                                      variant.name,
                                      value
                                    )
                                  }
                                  disabled={isDisabled} // Disable if combination not possible
                                >
                                  {value}
                                </button>
                              );
                            })}
                        </div>
                      </>
                    )}
                  </div>
                ))
              )}

              <div></div>

              {isLoading ? (
                <div
                  className="card-1 skeleton mb-2"
                  style={{
                    height: 40,
                    width: 80,
                    maxWidth: "100%",
                    borderRadius: 5,
                  }}
                ></div>
              ) : (
                <>
                  {Product?.type === true &&
                    selectedCombination.length !== 0 && (
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={removeSelectedFillter}
                      >
                        {" "}
                        <i className="ri-brush-3-fill"></i> Clear{" "}
                      </button>
                    )}
                </>
              )}


            </div>
            <hr />

            {isLoading ? (
              <>
                <div
                  className="card-1 skeleton mb-2"
                  style={{
                    height: 50,
                    width: 400,
                    maxWidth: "100%",
                    borderRadius: 10,
                  }}
                ></div>
              </>
            ) : (
              <>

                <div className="text-start mb-3">

                  <div className="quantity-products d-inline-flex p-2 rounded align-items-center" style={{ border: '1px solid black' }}>
                    {/* Decrement Button */}
                    <button
                      className="btn btn-sm btn-dark p-2"
                      onClick={handleDecrement}
                      aria-label="Decrement quantity"
                    >
                      <i className="ri-subtract-line" />
                    </button>

                    {/* Quantity Input */}
                    <input
                      id="quantityNumber1"
                      className="quantity-number form-control-sm text-center border-0"
                      type="number"
                      value={TotalQuantity}
                      max={Product?.stock} // max quantity based on stock
                      min={1} // Prevent entering numbers less than 1
                      onChange={handleQuantityChange}
                      aria-label="Product quantity"
                    />

                    {/* Increment Button */}
                    <button
                      className="btn btn-sm btn-dark  p-2"
                      onClick={() => handleIncrement(Product?.stock)}
                      aria-label="Increment quantity"
                    >
                      <i className="ri-add-line" />
                    </button>
                  </div>

                </div>
                <div className="d-flex gap-2 justify-content-between buy-float">
                  <button
                    // disabled={Product?.stock === 0}
                    className="btn btn-primary btn-sm d-flex align-items-center justify-content-center w-100 text-nowrap"
                    type="button"
                    onClick={() => {
                      if (Product.type) {
                        if (ProductsSale === 0) {
                          toast.error("Please Choose Attribute");
                        } else {
                          handleAddToCart({
                            id: Product._id + ProductuniqueId,
                            title: Product.title + ProductVariantName,
                            image:
                              MatchImages.length !== 0
                                ? MatchImages[0].src
                                : frontImage, // Remove the extra dot
                            regularPrice: ProductsRegular,
                            price: ProductsSale,
                            color: selectedColor,
                            customise: pdfBase64,
                            TotalQuantity: TotalQuantity,
                            weight: Product.weight,
                            gst: Product.gst,
                            stock: Product.stock,
                            pid: Product._id,
                          });
                        }
                      } else {
                        handleAddToCart({
                          id: Product._id + ProductuniqueId,
                          title: Product.title + ProductVariantName,
                          image:
                            MatchImages.length !== 0
                              ? MatchImages[0].src
                              : frontImage, // Remove the extra dot
                          regularPrice: ProductsRegular,
                          price: ProductsSale,
                          color: selectedColor,
                          customise: pdfBase64,
                          TotalQuantity: TotalQuantity,
                          weight: Product.weight,
                          gst: Product.gst,
                          stock: Product.stock,
                          pid: Product._id,
                        });
                      }
                    }}
                  >
                    <i className="ri-shopping-cart-2-line" />
                    <span className="ms-2 text-nowrap">Add To Cart</span>
                  </button>

                  <button
                    className="btn  btn-sm  bg-dark text-white d-flex align-items-center justify-content-center w-100"
                    type="button"
                    onClick={() => {
                      if (Product.type) {
                        if (ProductsSale === 0) {
                          toast.error("Please Choose Attribute");
                        } else {
                          handleBuyNow({
                            id: Product._id + ProductuniqueId,
                            title: Product.title + ProductVariantName,
                            image:
                              MatchImages.length !== 0
                                ? MatchImages[0].src
                                : frontImage, // Remove the extra dot
                            regularPrice: ProductsRegular,
                            price: ProductsSale,
                            TotalQuantity: TotalQuantity,
                            weight: Product.weight,
                            gst: Product.gst,
                            stock: Product.stock,
                            pid: Product._id,
                          });
                        }
                      } else {
                        handleBuyNow({
                          id: Product._id + ProductuniqueId,
                          title: Product.title + ProductVariantName,
                          image:
                            MatchImages.length !== 0
                              ? MatchImages[0].src
                              : frontImage, // Remove the extra dot
                          regularPrice: ProductsRegular,
                          price: ProductsSale,
                          color: selectedColor,
                          customise: pdfBase64,
                          TotalQuantity: TotalQuantity,
                          weight: Product.weight,
                          gst: Product.gst,
                          stock: Product.stock,
                          pid: Product._id,
                        });
                      }
                    }}
                  >
                    <i className="ri-shopping-cart-2-line text-white" />
                    <span className="d-sm-inline ms-2 text-white">
                      Book Now
                    </span>
                  </button>
                </div>
              </>
            )}

            <div className="d-none">
              {isLoading ? (
                <>
                  <div className="row" style={{ maxWidth: 300 }}>
                    <div className="col-6">
                      <div
                        className="card-1 skeleton mb-2"
                        style={{
                          height: 50,
                          width: "100%",
                          borderRadius: 10,
                        }}
                      ></div>
                    </div>
                    <div className="col-6">
                      <div
                        className="card-1 skeleton mb-2"
                        style={{
                          height: 50,
                          width: "100%",
                          borderRadius: 10,
                        }}
                      ></div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="d-flex pt-2 mb-4 col-lg-6">
                  <div className="w-50 me-3">
                    {SubmitWishlist ? (
                      <button
                        className="btn btn-accent d-block w-100"
                        type="button"
                        onClick={AddWhishlistData}
                      >
                        <i class="ri-heart-fill"></i> Add to Wishlist
                      </button>
                    ) : (
                      <button
                        class="btn btn-accent d-block w-100"
                        type="button"
                        disabled
                      >
                        <span class="ms-1">Loading...</span>
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </button>
                    )}
                  </div>
                  <div className="w-50">
                    {SubmitCompare ? (
                      <button
                        className="btn btn-accent d-block w-100"
                        type="button"
                        onClick={AddCompareData}
                      >
                        <i class="ri-refresh-line"></i> Compare
                      </button>
                    ) : (
                      <button
                        class="btn btn-accent d-block w-100"
                        type="button"
                        disabled
                      >
                        <span class="ms-1">Loading...</span>
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>

            {Product?.features && Product?.features.length > 0 && <>
              <h5 className="h6 mb-3 py-2 border-bottom">
                <i className="ri-information-line text-body-secondary fs-lg align-middle me-2" />
                Key Features
              </h5>
              <ul>

                {Product.features.map((feature) => (
                  <li key={feature._id}> {feature} </li>
                ))}
              </ul>
            </>
            }


            {/* Info List */}
          </div>



          <div className=" rounded mb-2" >
            <h5 className="h6 mb-3 py-2 border-bottom">
              <i className="ri-information-line text-body-secondary fs-lg align-middle me-2" />
              Description
            </h5>

            <div className="mb-4"
              dangerouslySetInnerHTML={{ __html: Product?.description }}
            />
          </div>

          <br />

        </div>
        <NavBar />
      </main>



    </>
  );
};

export default ProductSlug;
